import { Lock, MessageSquarePlus } from 'lucide-react'

export interface SessionDemarcationBarProps {
  kind: 'closed' | 'current'
  /** Fecha de cierre de la sesión anterior (kind === 'closed'). */
  closedAt?: string | null
  /** Motivo de cierre de la sesión anterior (kind === 'closed'). */
  closeReason?: string | null
  /** Fecha de inicio de la sesión (kind === 'current'). */
  startedAt?: string | null
}

function formatDate(value?: string | null): string | null {
  if (!value) return null
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return null
  return date.toLocaleDateString('es-ES', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

const CLOSE_REASON_FALLBACK = 'motivo no registrado'

/**
 * B) Demarcación de sesión en el historial unificado: separa visualmente las
 * sesiones cerradas previas del mismo contacto de la sesión activa, para que
 * el vendedor distinga el hilo actual del contexto histórico al hacer scroll.
 */
export function SessionDemarcationBar({ kind, closedAt, closeReason, startedAt }: SessionDemarcationBarProps) {
  if (kind === 'closed') {
    const formattedClosedAt = formatDate(closedAt)
    const reasonLabel = closeReason ? closeReason.replace(/_/g, ' ').toLowerCase() : CLOSE_REASON_FALLBACK
    return (
      <div
        className="my-4 flex items-center justify-center"
        data-testid="session-demarcation-closed"
      >
        <div className="flex items-center gap-2 rounded-full border border-gray-200 bg-gray-50 px-4 py-1.5 text-xs text-gray-500">
          <Lock className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
          <span>
            Conversación anterior cerrada{formattedClosedAt ? ` el ${formattedClosedAt}` : ''} por {reasonLabel}
          </span>
        </div>
      </div>
    )
  }

  const formattedStartedAt = formatDate(startedAt)
  return (
    <div className="my-2 flex items-center justify-center" data-testid="session-demarcation-current">
      <div className="flex items-center gap-2 rounded-full bg-emerald-50 px-3 py-1 text-[11px] font-semibold text-emerald-600">
        <MessageSquarePlus className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
        <span>Nueva conversación iniciada{formattedStartedAt ? ` el ${formattedStartedAt}` : ''}</span>
      </div>
    </div>
  )
}
